import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal-with-trigger.component";
import * as i4 from "../../../module-upsell/module-upsell.component";
import * as i5 from "../../../../../../../../charts/static/charts/ts/features/pie-chart/pie-chart.component";
function HoldingsByTypeTableComponent_ycn_pie_chart_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-pie-chart", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("chartDataJsonInput", ctx_r0.pieChartData);
} }
function HoldingsByTypeTableComponent_table_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 16)(1, "thead")(2, "tr");
    i0.ɵɵelement(3, "th");
    i0.ɵɵelementStart(4, "th", 17);
    i0.ɵɵtext(5, "Long");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 17);
    i0.ɵɵtext(7, "Short");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 17);
    i0.ɵɵtext(9, "Total");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "tbody")(11, "tr")(12, "td")(13, "span", 18);
    i0.ɵɵtext(14, "Stock");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "td", 17);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td", 17);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "td", 17);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "tr")(22, "td")(23, "span", 19);
    i0.ɵɵtext(24, "Bond");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "td", 17);
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "td", 17);
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "td", 17);
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "tr")(32, "td")(33, "span", 20);
    i0.ɵɵtext(34, "Other");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "td", 17);
    i0.ɵɵtext(36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "td", 17);
    i0.ɵɵtext(38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "td", 17);
    i0.ɵɵtext(40);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(41, "tr")(42, "td")(43, "span", 21);
    i0.ɵɵtext(44, "Total");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "td", 17);
    i0.ɵɵtext(46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "td", 17);
    i0.ɵɵtext(48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "td", 17);
    i0.ɵɵtext(50);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(16);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_long_stock_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_short_stock_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_stock_holdings")));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_long_bond_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_short_bond_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_bond_holdings")));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_long_other_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_short_other_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_other_holdings")));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_long_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_short_holdings")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_holdings")));
} }
function HoldingsByTypeTableComponent_table_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 16)(1, "thead")(2, "tr");
    i0.ɵɵelement(3, "th")(4, "th", 17)(5, "th", 17);
    i0.ɵɵelementStart(6, "th", 17);
    i0.ɵɵtext(7, "Total");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "tbody")(9, "tr")(10, "td")(11, "span", 18);
    i0.ɵɵtext(12, "Stock");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(13, "td", 17)(14, "td", 17);
    i0.ɵɵelementStart(15, "td", 17);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "tr")(18, "td")(19, "span", 19);
    i0.ɵɵtext(20, "Bond");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(21, "td", 17)(22, "td", 17);
    i0.ɵɵelementStart(23, "td", 17);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "tr")(26, "td")(27, "span", 20);
    i0.ɵɵtext(28, "Other");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(29, "td", 17)(30, "td", 17);
    i0.ɵɵelementStart(31, "td", 17);
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(33, "tr")(34, "td")(35, "span", 21);
    i0.ɵɵtext(36, "Total");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(37, "td", 17)(38, "td", 17);
    i0.ɵɵelementStart(39, "td", 17);
    i0.ɵɵtext(40);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(16);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_equity_holdings_generic")));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_bond_holdings_generic")));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_other_holdings_generic")));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r0.getValueForCalc(ctx_r0.holdingsByTypeCalcData.get("number_of_holdings_generic")));
} }
function HoldingsByTypeTableComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("As of ", ctx_r0.portfolioDate, "");
} }
// Constants & utils
/**
 *
 * ModelPortfolioHoldingsByTypeTable.
 *
 */
export class HoldingsByTypeTableComponent {
    constructor(featureService) {
        this.featureService = featureService;
    }
    userHasFeature(feature) {
        return this.featureService.userHasFeatures([feature]);
    }
    getValueForCalc(calc) {
        if (typeof calc === 'undefined' || calc.value === null) {
            return '--';
        }
        return calc.value;
    }
}
HoldingsByTypeTableComponent.ɵfac = function HoldingsByTypeTableComponent_Factory(t) { return new (t || HoldingsByTypeTableComponent)(i0.ɵɵdirectiveInject(i1.FeatureService)); };
HoldingsByTypeTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsByTypeTableComponent, selectors: [["ycn-holdings-by-type-table"]], inputs: { holdingsByTypeCalcData: "holdingsByTypeCalcData", pieChartData: "pieChartData", portfolioDate: "portfolioDate", usesGenericData: "usesGenericData" }, decls: 18, vars: 6, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], ["modalName", "holdings_type_module", "triggerLabel", "(?)"], [1, "panel-content"], [3, "title"], [1, "row"], [1, "col-5", "col-md-12", "col-chart-wrap"], [1, "chart-wrap"], [1, "chart-pie"], [3, "chartDataJsonInput", 4, "ngIf"], [1, "panel-date", "hidden-md"], [1, "col-7", "col-md-12"], ["class", "table", 4, "ngIf"], [4, "ngIf"], [3, "chartDataJsonInput"], [1, "table"], [1, "text-right"], [1, "chart-legend-item-title", "bullet-1"], [1, "chart-legend-item-title", "bullet-2"], [1, "chart-legend-item-title", "bullet-3"], [1, "chart-legend-item-title", "bullet-none"], [1, "panel-date", "visible-md-block"]], template: function HoldingsByTypeTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, " Holdings by Type \u00A0");
        i0.ɵɵelement(4, "ycn-help-modal-with-trigger", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelement(6, "ycn-module-upsell", 5);
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "div", 8)(10, "div", 9);
        i0.ɵɵtemplate(11, HoldingsByTypeTableComponent_ycn_pie_chart_11_Template, 1, 1, "ycn-pie-chart", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "div", 12);
        i0.ɵɵtemplate(15, HoldingsByTypeTableComponent_table_15_Template, 51, 12, "table", 13)(16, HoldingsByTypeTableComponent_table_16_Template, 41, 4, "table", 13)(17, HoldingsByTypeTableComponent_ng_container_17_Template, 3, 1, "ng-container", 14);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("title", "Holdings by Type");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.userHasFeature("metric"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("As of ", ctx.portfolioDate, "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.usesGenericData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.usesGenericData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.portfolioDate !== null);
    } }, dependencies: [i2.NgIf, i3.HelpModalWithTriggerComponent, i4.ModuleUpsellComponent, i5.PieChartComponent], encapsulation: 2 });
